import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en.json';
import ar from './locales/ar.json';

const resources = {
  en: {
    translation: en,
  },
  ar: {
    translation: ar,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    debug: false,
    
    interpolation: {
      escapeValue: false,
    },
    
    detection: {
      // Detect from URL path first (e.g., /ar), then localStorage (returning users),
      // then navigator for first-time visitors, then htmlTag.
      order: ['path', 'localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      // For path detection, use the first segment: /ar -> 'ar'
      lookupFromPathIndex: 0,
      // Convert language codes to our supported languages
      convertDetectedLanguage: (lng: string) => {
        // Handle language codes like 'ar-SA', 'en-US', etc.
        const language = lng.split('-')[0];
        // Only return supported languages, otherwise return English
        return ['en', 'ar'].includes(language) ? language : 'en';
      },
      // Only detect from navigator if no localStorage value exists
      lookupLocalStorage: 'i18nextLng',
    },
  });

export default i18n;